<template lang="pug">
div
  announcement
  .container
    .member-wrapper
      memberMenu
      .member-content
        .member-title {{ $t("ui.password_change") }}
        .member-form
          form
            .form-field
              .form-label {{ $t("ui.password_current") }}
              .input-group
                input.form-control(
                  type='password'
                  v-model.trim.lazy="$v.oldPassword.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.oldPassword" :name="$t('ui.password_current')")  
            .form-field
              .form-label {{ $t("ui.password_new") }}
              .input-group
                input.form-control(
                  type='password'
                  v-model.trim.lazy="$v.newPassword.$model"
                  :disabled="loading"
                  :maxLength="$v.newPassword.$params.maxLength.max"
                )
              ValidateResult(:value="$v.newPassword" :name="$t('ui.password_new')" :name2="$t('ui.password_current')")  
            .form-field
              .form-label {{ $t("ui.password_confirm") }}
              .input-group
                input.form-control(
                  type='password'
                  v-model.trim.lazy="$v.confirmPassword.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.confirmPassword" :name="$t('ui.password_confirm')" :name2="$t('ui.password_new')")  
            .btn-form.py-2.py-xl-3
              a(href='javascript:void(0);' @click="updatePassword")
                .btn-submit {{ $t("ui.save") }}
  //- seo
</template>

<script>
import { required, minLength, maxLength, sameAs, not } from 'vuelidate/lib/validators'

export default {
  components: {
    announcement: () => import("@/components/_announcement"),
    memberMenu: () => import("@/components/_memberMenu"),
    seo: () => import("@/components/_seo"),
    ValidateResult: () => import("@/library/ValidateResult")
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    }
  },
  validations: {
    oldPassword: {
      required
    },
    newPassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20),
      notSameAs: not(sameAs('oldPassword')),
      passwordFormat: function(value){
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        //const containsSpecial = /[#?!@$%^&*-]/.test(value)
        return containsUppercase && containsLowercase && containsNumber;
      }
    },
    confirmPassword: {
      required,
      sameAs: sameAs("newPassword")
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
  methods:{
    updatePassword(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          let login_id = this.accountID
          let password = this.oldPassword
          let new_password = this.newPassword
          let auth_token = this.sessionToken
          this.loading = true
          this.$store
            .dispatch("user/updatePassword", { login_id, password, new_password, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.reset()
                this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.password_success"), "success");
              } else {
                this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error");
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              this.feedback.status = this.$t("error." + response.status)
              this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error");
            });
        }
      }
    },
    reset() {
      this.oldPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    }
  }
}
</script>